module.exports = __webpack_public_path__ + "static/media/academy-one-logo-no background.d1fd62ec.png";